import React, { useMemo, useState, useEffect } from "react";
import ToggleButtonsTrasnferList from "./components/ToggleButton";
import Dialog from "@material-ui/core/Dialog";
import TargetVsAchivementWidget from "./TargetVsAchivementWidget";
import AxiosClient from "../../Network/AxiosClient";
import DashboardCardHeader from "./components/DashboardCardHeader";
import "./styles/TargetVsAchivementBreakdown.scss";
import { makeStyles } from "@material-ui/core";
import { formatDate } from "./helper/format";
import Loader from "../Shared/Loader";
import BounceLoader from "react-spinners/FadeLoader";
import RightIcon from "./icons/chevron_right.svg";
import ReturnIcon from "./icons/arrow-return-right.svg";
import CloseIcon from "./icons/close.svg";
const tabConfig = () => [{ label: "MTD Target" }, { label: "Monthly Target" }];
const tabConfigOverall = [{ label: "Eligible" }, { label: "Total" }];
const typeConfig = [
  { label: "Acquistion", id: "acquisition" },
  { label: "Payment Amount", id: "payment_amount" },
  { label: "Active Merchant", id: "active_merchant" },
  { label: "Bill Payment", id: "bill_payment" },
  { label: "App login", id: "app_login" },
];
const hierarchyLabelConfig = {
  region: "Circle",
  area: "Zone",
  territory: "Territory",
  agency: "Distributor",
};
const RootLabelConfig = {
  region: "All Circles",
  area: "All Zones",
  territory: "All Territories",
  agency: "All Distributors",
};
const useStyle = makeStyles((theme) => {
  return {
    breakDownButton: {
      background: "linear-gradient(255.7deg, #FF66A9 0%, #F53689 100%)",
      boxShadow: "0px 8px 16px 0px rgba(54, 43, 115, 0.08)",
      boxShadow: "0px 2px 8px 0px rgba(54, 43, 115, 0.04)",
      fontFamily: "Inter",
      fontSize: 14,
      fontWeight: 400,
      color: "white",
      padding: theme.spacing(1, 2),
      borderRadius: theme.spacing(3),
      border: "none",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      "&:focus": {
        background: "linear-gradient(255.7deg, #FF66A9 0%, #F53689 100%)",
      },

      "&:hover": {
        background:
          "linear-gradient(255.7deg, rgb(54 43 115 / 78%) 0%, #f53689 100%)",
      },
    },
    closeButton: {
      background: "white",
      boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.1)",
      marginLeft: 12,
      fontFamily: "Inter",
      fontSize: 14,
      fontWeight: 400,
      color: "white",
      padding: theme.spacing(1, 2),
      borderRadius: theme.spacing(3),
      border: "none",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      "&:focus": {
        background: "linear-gradient(255.7deg, #ffffff 0%, #f5368973 100%)",
      },

      "&:hover": {
        background: "linear-gradient(255.7deg, #ffffff 0%, #f5368973 100%)",
      },
    },
    dialog: {
      borderRadius: 12,
    },
    card: {
      background: "rgba(234, 238, 249, 1)",
      padding: theme.spacing(3),
    },
    cardHeader: {
      marginTop: theme.spacing(0.5),
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontWeight: 600,
      marginLeft: 0,
    },
    toggleButtonContainer: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
    },
    updateDate: {
      color: "rgba(54, 43, 115, 0.56)",
      margin: "0",
      fontSize: 12,
      fontWeight: 400,
    },
    widgetContainer: {
      background: "white",
      height: "45vh",
      overflowY: "auto",
      position: "relative",
      borderRadius: 12,
      padding: theme.spacing(4),
      paddingBottom: theme.spacing(4),
      paddingTop: 0,
    },
    widgetHeader: {
      color: "rgba(54, 43, 115, 0.8)",
      fontSize: 20,
      fontFamily: "Inter",
      fontWeight: 700,
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      position: "sticky",
      top: 0,
      background: "white",
      paddingTop: theme.spacing(4),
    },
    container: {
      display: "flex",
      width: "100%",
      flexWrap: "wrap",
      paddingBottom: 16,
    },
    typeButtonGroups: {
      marginTop: 20,
      display: "flex",
      flexDirection: "row",
      "& button": {
        border: "none",
        marginRight: 10,
        borderRadius: 16,
        fontSize: 12,
        fontFamily: "Inter",
        padding: "8px 16px",
        width: 165,
        fontWeight: 400,
        color: "rgba(0, 14, 61, 1)",
        "&:hover": {
          backgroundColor: "rgba(255, 239, 246, 1)!important",
        },
      },
    },
    fetchingOverlay: {
      position: "absolute",
      zIndex: 40,
      background: "#eaeef99c",
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      left: "50%",
      transform: "translate(-50%,0)",
      top: 0,
      backdropFilter: "blur(4px)",
      borderRadius: 12,
      "& h2": {
        fontFamily: "Inter",
        fontSize: 24,
        color: "#e2136eb0",
        marginTop: -theme.spacing(3),
      },
    },
    wrapper: {
      display: "flex",
      alignItems: "center",
      marginTop: 12,
      width: "100%",
      padding: theme.spacing(0, 2),
    },
    breadcrumb: {
      display: "flex",
      padding: "14px 0px",
      marginLeft: 12,
      "& p": {
        fontFamily: "Inter",
        margin: 0,
        color: "#362b73",
        fontWeight: 500,
        fontSize: 13,
        color: "rgba(255, 102, 169, 1)",
        width: "fit-content",
        whiteSpace: "nowrap",
        "&:hover": {
          textDecoration: "underline",
          cursor: "pointer",
        },
      },
    },
    item: {
      fontFamily: "Inter",
      width: "10%",
      color: "#E2136E",
      fontWeight: 500,
      fontSize: 12,
    },
  };
});

const config = (element, type) => {
  if (type === "acquisition")
    return {
      header: element.name,
      target: element.acquisition,
      achived: element.achievement,
      remaining: element.remaining,
      dailyRequired: element.daily_required,
    };

  if (type === "payment_amount")
    return {
      header: element.name,
      target: element.payment_target,
      achived: element.payment_amount,
      remaining: element.remaining,
      dailyRequired: element.daily_required,
      achievementEligible: element.payment_amount_eligible,
      remainingEligible: element.remaining_eligible,
      dailyRequiredEligible: element.daily_required_eligible,
      isEligible: true,
    };

  if (type === "active_merchant")
    return {
      header: element.name,
      target: element.active_merchant_target,
      achived: element.active_merchant,
      remaining: element.remaining,
      dailyRequired: element.daily_required,
      achievementEligible: element.active_merchant_eligible,
      remainingEligible: element.remaining_eligible,
      dailyRequiredEligible: element.daily_required_eligible,
      isEligible: true,
    };

  if (type === "bill_payment")
    return {
      header: element.name,
      target: element.bill_payment_target,
      achived: element.bill_payment,
      remaining: element.remaining,
      dailyRequired: element.daily_required,
    };
  if (type === "app_login")
    return {
      header: element.name,
      target: element.app_login_target,
      achived: element.app_login_mtd,
      remaining: element.remaining,
      dailyRequired: element.daily_required,
    };
};

function TargetVsAchivementBreakdown() {
  const classes = useStyle();
  const [data, setData] = React.useState(null);
  const [fetching, setFetching] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [tabIndex, setTabIndex] = React.useState(0);
  const [tabIndexOverall, setTabIndexOverall] = React.useState(1);
  const [params, setParams] = useState({ type: "acquisition" });
  const [nav, setNav] = useState([]);

  useEffect(() => {
    fetchData();
    setTabIndexOverall(0);
    if (params.type === "payment_amount" || params.type === "active_merchant")
      setTabIndexOverall(0);
    else setTabIndexOverall(1);
  }, [params]);

  useEffect(() => {
    console.log(nav);
  }, [nav]);

  const onTabChange = (index) => {
    if (index == null) return;
    setTabIndex(index);
  };
  const onTabChangeOverall = (index) => {
    if (index == null) return;
    setTabIndexOverall(index);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);
  };

  const callBackFromWidget = (info) => {
    if (data.child)
      setParams({
        ...params,
        group_by: data.child,
        id: info.id,
        name: info.name,
      });

    console.log(info);
  };

  const onClickTypeButton = (id) => {
    setParams({ ...params, type: id });
  };

  const onClickBreadCrumb = (crumb, index) => {
    console.log(crumb);
    if (index === nav.length - 1) return;
    let navStack = [...nav];
    setNav(navStack.slice(0, index));
    setParams({ ...crumb, type: params.type });
  };

  const fetchData = () => {
    setFetching(true);
    AxiosClient.get(
      `${process.env.REACT_APP_API_URL}/api/reports/dashboard/detail-target-vs-achievement`,
      {
        params: params,
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
        },
      }
    )
      .then((res) => {
        if (data?.parent !== res.data.parent) {
          let navStack = [...nav];
          let p = { ...params };
          delete p["type"];
          navStack.push({
            ...p,
            group_by: res.data.parent,
          });
          setNav(navStack);
        }
        setFetching(false);
        setData(res.data);
      })
      .catch((err) => {
        console.log(err);
        setFetching(false);
      });
  };
  if (!data || (Array.isArray(data) && data.length === 0)) return;
  return (
    <div>
      <button className={classes.breakDownButton} onClick={handleClickOpen}>
        <img src={ReturnIcon} />
        View Breakdown
      </button>
      <Dialog
        open={open}
        fullWidth={true}
        onClose={() => {}}
        maxWidth="lg"
        PaperProps={{
          style: { borderRadius: 12 },
        }}
      >
        <div className={classes.card}>
          <DashboardCardHeader
            className={classes.cardHeader}
            label={`${
              data ? hierarchyLabelConfig[data.parent] + " Wise " : ""
            }Targets VS Achievements Breakdown`}
            styles={{
              labelClass: { color: "rgba(54, 43, 115, 1)", fontWeight: 600 },
            }}
            subLabel={
              data && (
                <p className={classes.updateDate}>
                  Updated till - {formatDate(data.last_parsed_time)}
                </p>
              )
            }
          >
            <div className={classes.toggleButtonContainer}>
              <ToggleButtonsTrasnferList
                config={tabConfig()}
                {...{ tabIndex, onTabChange }}
              />
              {data &&
                (data.type === "payment_amount" ||
                  data.type === "active_merchant") && (
                  <div style={{ marginLeft: 12 }}>
                    <ToggleButtonsTrasnferList
                      config={tabConfigOverall}
                      tabIndex={tabIndexOverall}
                      onTabChange={onTabChangeOverall}
                    />
                  </div>
                )}
              <button className={classes.closeButton} onClick={handleClose}>
                <img src={CloseIcon} />
              </button>
            </div>
          </DashboardCardHeader>
          <div className={classes.typeButtonGroups}>
            {typeConfig.map((t) => (
              <button
                key={t.label}
                style={{
                  color:
                    params.type === t.id
                      ? "rgba(226, 19, 110, 1)"
                      : "rgba(0, 14, 61, 1)",
                  background:
                    params.type === t.id
                      ? "rgba(255, 239, 246, 1)"
                      : "rgba(255, 255, 255, 1)",
                }}
                onClick={() => onClickTypeButton(t.id)}
              >
                {t.label}
              </button>
            ))}
          </div>
          <div className={classes.breadcrumb}>
            {nav.map((n, _i) => (
              <div
                key={n.name ?? n.group_by}
                onClick={() => onClickBreadCrumb(n, _i)}
                style={{ display: "flex", flexDirection: "row" }}
              >
                <p
                  style={{
                    color:
                      _i === nav.length - 1
                        ? "rgba(54, 43, 115, 1)"
                        : "rgba(255, 102, 169, 1)",
                  }}
                >
                  {n.name ?? RootLabelConfig[n.group_by] ?? "Root"}
                </p>
                {_i !== nav.length - 1 && (
                  <img src={RightIcon} style={{ margin: "0px 4px" }} />
                )}
              </div>
            ))}
          </div>
          <div className={classes.widgetContainer}>
            <div className={classes.widgetHeader}>
              {typeConfig.find((t) => t.id === params.type)?.label}
            </div>
            {fetching && (
              <div className={classes.fetchingOverlay}>
                <BounceLoader color="#e2136e" />
              </div>
            )}

            {data && data.data.length === 0 && (
              <div className={classes.fetchingOverlay}>
                <h2>
                  No data for{" "}
                  {typeConfig.find((t) => t.id === params.type)?.label}{" "}
                </h2>
              </div>
            )}

            <div
              className={classes.wrapper}
              style={{
                paddingBottom: 16,
                marginTop: 0,
                paddingTop: 12,
                background: "white",
                position: "sticky",
                top: 65,
              }}
            >
              <div className={classes.item} style={{ width: "20%" }}>
                Item
              </div>
              <div className={classes.item} style={{ textAlign: "center" }}>
                Target
              </div>
              <div className={classes.item} style={{ textAlign: "center" }}>
                Achievement
              </div>
              <div className={classes.item} style={{ textAlign: "center" }}>
                %
              </div>
            </div>
            {data?.data.map((element, _i) => {
              const t = config(element, params.type);
              return (
                <TargetVsAchivementWidget
                  element={t}
                  tabIndex={tabIndex}
                  index={_i}
                  key={_i + element.id ?? element.group_by}
                  isLast={_i === data?.data.length}
                  isInEligibleTab={
                    t.isEligible &&
                    tabConfigOverall[tabIndexOverall].label === "Eligible"
                  }
                  lastParsedTime={data.last_parsed_time ?? new Date()}
                  isClickable={data.child ? true : false}
                  onClickWidget={() => callBackFromWidget(element)}
                />
              );
            })}
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default TargetVsAchivementBreakdown;
